import { TAppState } from '../../types/appState';

export const usersStatusSelector = (state: TAppState) => state.usersStatus;
